import {
  IRespondentWithAnswers,
  IRespondentFile,
  RespondentSource,
} from '../models/data-capture.models';

export const baseRespondentFileMock: IRespondentFile = {
  fileName: 'fileName',
  fileExtension: 'txt',
  fileKey: 'fileName.txt',
  type: 'manual',
};

export const respondentMock: IRespondentWithAnswers = {
  respondentId: '1',
  firstName: 'John',
  lastName: 'Doe',
  geography: 'US',
  segment: 'Nurse',
  opportunitySegmentId: '1',
  callDate: '2025-01-13T00:00:00.000Z',
  bio: '',
  type: RespondentSource.Techspert,
  source: 'expertId',
  answers: {},
  files: [],
};

export const respondentsMock: IRespondentWithAnswers[] = [
  {
    respondentId: '1',
    firstName: 'Elizabeth Garrett',
    lastName: 'Anderson',
    geography: 'UK',
    segment: 'Surgeon',
    opportunitySegmentId: '1',
    callDate: '1899-01-01T00:00:00.000Z',
    bio: '',
    type: RespondentSource.Techspert,
    source: 'expertId',
    answers: {},
    files: [],
  },
  {
    respondentId: '2',
    firstName: 'Daniel',
    lastName: 'Williams',
    geography: 'US',
    segment: 'Surgeon',
    opportunitySegmentId: '1',
    callDate: '1920-01-01T00:00:00.000Z',
    bio: '',
    type: RespondentSource.Techspert,
    source: 'expertId',
    answers: {},
    files: [],
  },
  {
    respondentId: '3',
    firstName: 'Rebecca Lee',
    lastName: 'Crumpler',
    geography: 'US',
    segment: 'Physician',
    opportunitySegmentId: '1',
    callDate: '1865-01-01T00:00:00.000Z',
    bio: '',
    type: RespondentSource.Techspert,
    source: 'expertId',
    answers: {},
    files: [],
  },
  {
    respondentId: '4',
    firstName: 'Joseph',
    lastName: 'Lister',
    geography: 'UK',
    segment: 'KOL',
    opportunitySegmentId: '1',
    callDate: '1867-01-01T00:00:00.000Z',
    bio: '',
    type: RespondentSource.Techspert,
    source: 'expertId',
    answers: {},
    files: [],
  },
];
